import { render, staticRenderFns } from "./alpha.vue?vue&type=template&id=d3c51de2&"
import script from "./alpha.vue?vue&type=script&lang=js&"
export * from "./alpha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports